import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { element } from 'protractor';
import swal from 'sweetalert2';

import { ServicesService } from '../../services/services.service';

// import { forEach } from '@angular/router/src/utils/collection';
@Component({
  selector: 'app-create-virtual-orders',
  templateUrl: './create-virtual-orders.component.html',
  styleUrls: ['./create-virtual-orders.component.css']
})
export class CreateVirtualOrdersComponent implements OnInit {

  cid:any;
  clientName:any;
  currentPage: number = 1;
  // loader: boolean = false;
  paginate= {
    'last_page' : 1
  };
  searchFields= [];
  pages: any;
  editData: Object = {};
  routePath:any;
  listData:any;
  fields:any;
  showloader=false;
  submitted=false;
  cname:any;
  information=false;
  selectedProduct = '';
  inputValidate = []

  component: Object = {};
  orderDetails: any = {
    'client_id':'',
    'order_no_unique' : '',
    'order_date' : '',
    'product' : [],
    'productData' : [],
    'component' : [],
    'componentData' : [],
    'project_order_id':'',
  };

  constructor(private route: ActivatedRoute, private _services: ServicesService, private router: Router) {
    this.route.queryParams.subscribe(params=>{
      this.cid = params['cid'];
      this.cname = params['cname'];
      this.orderDetails['client_id'] = this.cid;
    })
  }

  ngOnInit() {
    this.clientName = this.cname;
    this._services.checkToken('status');
    this.getProductsComponents();
    this.getOrderProjectList();

    $('#productSel').change(function(){
      //console.log('#' + $(this).val());
      $('#' + $(this).val()).show();
    });

    let now = new Date();
    let currentMont = now.getMonth() + 1;
    let randomNumPart = Math.floor((Math.random() * 99)).toString().padStart(2, '0');
    this.orderDetails['order_no_unique'] =  now.getDate() + '' + currentMont + '' + now.getFullYear() + '' + randomNumPart;

    this.fields = [
      {
        'field' : 'component_name',
        'title' : 'Component Name',
        'width' : '30%',
        'code'  : true,
        'sort'  : false,
      },
      {
        'field' : 'quantity',
        'title' : 'Quantity',
        'width' : '25%',
        'code'  : false,
        'sort'  : false,
      }
    ]
  }


  crateOrder(){
    // //console.log(this.orderDetails['project_order_id']);
    this.orderDetails['product'] = Array.from(new Set(this.orderDetails['product'] ));
    this.orderDetails['componentData'] = Array.from(new Set(this.orderDetails['componentData'] ));
    this.orderDetails['total_amt'] = this.totalAmt;
    this.orderDetails['order_amt'] = this.orderAmt;
    var main_counter = 0;
    var counter = 0;
    var flag1 = 0;
    var flag2 = 0;
    var flag3 = 0;
    var flag4 = 0;
    let i=0;
    //console.log("this.orderDetails['productData']",this.orderDetails['productData']);
    if( this.orderDetails['product'] && this.orderDetails['componentData'] && this.orderDetails['total_amt'] && this.orderDetails['order_amt'] && this.orderDetails['productData']){
      this.orderDetails['productData'].forEach(obj => {
        // //console.log('obj length: ',obj);
        //console.log('components_list ',obj.components_list.length);
        let null_counter = 0;
        // if(flag4==0) {
        obj.components_list.forEach(childObj => {
          if (!childObj.qty) {
            ++null_counter;
          }
          if (obj.components_list.length == null_counter) {
            flag4 = 1;
            this.inputValidate[main_counter] = 1;
          }
          // alert(childObj.qty);
          /* if(childObj.qty) {
           if(obj.product_id == this.orderDetails['product'][main_counter-1]) {
           counter = counter +1;
           }
           }*/
        })
        // }
        if(flag4==0){
          this.inputValidate[main_counter] = 0;
        }
        if(flag4==1){
          this.inputValidate[main_counter] = 1;
          /*swal({
           type: 'warning',
           title: 'Oops...',
           text: 'Please fill atleast one category'
           })
           return;*/
        }
        if(obj.quantity) {
          flag1 = 1;
        } else {
          flag1 = 1;
        }
        if(obj.description) {
          flag2 = 1;
        } else {
          flag2 = 0;
        }
        if(obj.amount) {
          flag3 = 1;
        } else {
          flag3 = 0;
        }
        main_counter++;
      });
      if(flag1 == 1 && flag2 == 1 && flag3 == 1 && flag4 == 0) {
        this.showloader=true;
        this._services.requestCreator(this.orderDetails,'create-client-virtual-order',this._services.getToken()).subscribe((data: any) => {
          if(this._services.checkToken(data.status)){
            if(data.status == '200'){
              // this.isFormSubmitted=false;
              this.showloader=true;
              swal({
                title: 'Order Add Successfully',
                text: 'You Successfully Added Order',
                type: 'success',
                showCancelButton: false,
                confirmButtonColor: 'rgb(17, 205, 239)',
                cancelButtonColor: 'rgb(245, 54, 92)',
                confirmButtonText: 'Yes'
              }).then(() => {
                this.orderDetails = {};
                this.showloader=true;
                this.router.navigateByUrl('/client-virtual-orders-list', {queryParams:{'cid':this.cid}});
              })
            } else{
              this.showloader=false;
              // this.isFormSubmitted=false;
            }
          }
        });
      } else {
        /*swal({
         type: 'warning',
         title: 'Oops...',
         text: 'Please fill all the fields!'
         })*/
      }
    }else{
      /* swal({
       type: 'warning',
       title: 'Oops...',
       text: 'Please fill all the fields!'
       })*/
    }
  }

  getProductsComponents(){
    this.routePath  = 'get-products-components-list';
    let data={
      'client_id':this.cid,
    }
    const token    = localStorage.getItem('userToken');
    this._services.requestCreator(data, this.routePath, token).subscribe((result: any) => {
      if(this._services.checkToken(result.status)){
        this.listData = result.result;
      }
    });
    return true;
  }

  insertProductData(element){
    this.orderAmt = 0;
    this.totalAmt = 0;
    this.taxAmt = 0;

    this.orderDetails['productData'][element.product_id] = element;

    for(let key in this.orderDetails['productData']){
      this.orderAmt += (this.orderDetails['productData'][key]['amount'] * this.orderDetails['productData'][key]['quantity'])?this.orderDetails['productData'][key]['amount'] * this.orderDetails['productData'][key]['quantity']:0;
    }
    this.taxAmt = this.orderAmt*.15;
    this.totalAmt = this.orderAmt + this.taxAmt;
  }

  enableInputField(componentId, rate, productId){
    this.orderAmt = 0;
    this.totalAmt = 0;
    this.taxAmt = 0;
    //console.log(this.orderDetails['component'][componentId]);
    let componentData = {
      'id' : componentId,
      'quantity' : this.orderDetails['component'][componentId],
      'total' : this.orderDetails['component'][componentId] * rate,
      'product_id': productId,
    }

    $('#component_total_'+componentId).html(`${this.orderDetails['component'][componentId] * rate}`);
    this.orderDetails['componentData'].push(componentData);
    //console.log(this.orderDetails['componentData']);
    for(let key in this.orderDetails['componentData']){
      this.orderAmt += this.orderDetails['componentData'][key]['total'];
    }
    this.taxAmt = this.orderAmt*.15;
    this.totalAmt = this.orderAmt + this.taxAmt;

  }
  orderAmt:any=0;
  totalAmt:any=0;
  taxAmt:any=0;
  tempProductId:any;

  getProduct(product){
    this.orderDetails['product'].push(product);
    this.tempProductId = product;

    // //console.log(this.tempProductId);
  }

  routeData;
  orderProjectList:any;
  getOrderProjectList(){
    let data;
    this.routeData = 'get-project-virtual-order-list';

    switch(this.routeData){

      case 'get-project-virtual-order-list':{
        data = {
          page  : this.currentPage,
          search: {
            'project_name' : this.searchFields['project_name'],
          }
        };
        break;
      }
    }
    const token = localStorage.getItem('userToken');
    this._services.requestCreator(data, this.routeData, token).subscribe((result: any) => {
      if(this._services.checkToken(result.status)){
        //console.log(result.result);
        this.orderProjectList = result.result;
        //console.log(this.orderProjectList);
      }
    });

    return true;
  }



}
